import { ROUTES } from '@shared/utils';
import { AGE_SAFE_IMAGES } from '../../Footer/UnderageSection/underageSectionImages';
import type { SaferGamblingImage } from './HomePageSaferGambling';

const DEFAULT_IMAGES: SaferGamblingImage[] = [
  { src: AGE_SAFE_IMAGES.GAMSTOP, href: ROUTES.FOOTER.LEGAL.GAMSTOP, alt: 'GAMSTOP', trackName: 'GamStop', width: 160, height: 160, className: 'w-full h-35' },
  {
    src: AGE_SAFE_IMAGES.NATIONAL_GAMBLING_HELPLINE,
    href: ROUTES.FOOTER.LEGAL.GAMCARE,
    alt: 'National Gambling Helpline',
    trackName: 'National Gambling Helpline',
    width: 160,
    height: 160,
    className: 'w-full h-35',
  },
  { src: AGE_SAFE_IMAGES.GAMBLE_AWARE, href: ROUTES.FOOTER.LEGAL.GAMBLE_AWARE, alt: 'Gamble Aware', trackName: 'Gamble Aware', width: 160, height: 160, className: 'w-full h-30' },
  {
    src: AGE_SAFE_IMAGES.GAMBLE_ANONYMOUS,
    href: ROUTES.FOOTER.LEGAL.GAMBLERS_ANONYMOUS,
    alt: 'Gamble Anonymous',
    trackName: 'Gamble Anonymous',
    width: 250,
    height: 90,
    className: 'w-60 h-20',
  },
  {
    src: AGE_SAFE_IMAGES.TAKE_TIME_TO_THINK,
    href: ROUTES.FOOTER.LEGAL.TAKE_TIME_TO_THINK,
    alt: 'Take Time to Think',
    trackName: 'Take Time to Think',
    width: 160,
    height: 160,
    className: 'w-full h-30',
  },
];

export { DEFAULT_IMAGES };
